// De teksten van de adres- en naamstap vóór een openbare vragenlijst, op sleutel.
//
// Eén lijst per stap voor twee afnemers: de stap zelf (Nederlandse terugval) en
// QuestionnaireOpen, die ze ter vertaling meestuurt. Tot 2026-10-13 stonden ze
// alleen in de JSX van de stappen, en bleef zo'n stap in elke taal Nederlands.
// Een eigen bestand (niet in de componenten) zodat een test die een stap
// vervangt door een nepversie de teksten niet stil kwijtraakt.
// AI-CONTEXT: See docs/features/deelnemer-koppeling-algemene-link.md

/** @type {Record<string, string>} */
export const ADDRESS_STEP_TEXTS = {
    'Adresstap ongeldig': 'Vul een geldige postcode en een huisnummer in.',
    'Adresstap meerdere woningen': 'Op dit adres zijn meerdere woningen. Kies hieronder je toevoeging.',
    'Adresstap niet gevonden': 'Dit adres is niet gevonden in het adressenregister. Controleer de postcode en het huisnummer.',
    'Adresstap fout': 'Je adres kon nu niet worden opgeslagen. Probeer het opnieuw.',
    'Adresstap titel': 'Je adres',
    'Adresstap uitleg': 'We vragen je adres. Zo weten we bij welk huishouden je antwoorden horen.',
    'Postcode': 'Postcode',
    'Huisnummer': 'Huisnummer',
    'Toevoeging (optioneel)': 'Toevoeging (optioneel)',
    'Zonder toevoeging': 'Zonder toevoeging',
    'Adresstap klopt': 'Het adres klopt, ga verder',
    'Bezig': 'Bezig…',
    'Verder': 'Verder',
}

/** @type {Record<string, string>} */
export const NAME_STEP_TEXTS = {
    'Naamstap titel': 'Je naam',
    'Naamstap uitleg': 'We vragen je naam, zodat je antwoorden bij jou bewaard worden. Je antwoorden zijn daardoor niet anoniem.',
    'Voornaam': 'Voornaam',
    'Achternaam': 'Achternaam',
    'Naamstap ongeldig': 'Vul je voornaam en achternaam in.',
    'Naamstap tekens': 'Je naam bevat een tab of een nieuwe regel. Typ hem op één regel.',
    'Naamstap fout': 'Je naam kon nu niet worden opgeslagen. Probeer het opnieuw.',
    'Bezig': 'Bezig…',
    'Verder': 'Verder',
}

export default { ADDRESS_STEP_TEXTS, NAME_STEP_TEXTS }
